(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("ElementUI"), require("Vue"));
	else if(typeof define === 'function' && define.amd)
		define(["ElementUI", "Vue"], factory);
	else if(typeof exports === 'object')
		exports["dddVirtualTree"] = factory(require("ElementUI"), require("Vue"));
	else
		root["dddVirtualTree"] = factory(root["ElementUI"], root["Vue"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__282__, __WEBPACK_EXTERNAL_MODULE__2508__) {
return 